import RestaurantLayout from './RestaurantLayout';

export { RestaurantLayout };
